'use strict';

define(['app'], function (app) {

  var productBuyNowPayLaterProviders = function productBuyNowPayLaterProviders() {
    var component = {};

    var _config = {
      selectors: {
        component: '[data-component=productBuyNowPayLaterProviders]'
      },
      subscribeChannels: {
        BNPLProvidersInfo: 'productBuyNowPayLaterProviders/providersInfo'
      },
      dataAttributes: {
        isDesktop: 'data-isDesktop'
      }
    };

    var _init = function _init(element, userDriven, isDesktop) {
      component.element = element;

      if (isDesktop) {
        component.isDesktop = isDesktop;
      } else {
        component.isDesktop = component.element.getAttribute(component.config.dataAttributes.isDesktop);
      }

      if (!userDriven) {
        app.subscribe(component.config.subscribeChannels.BNPLProvidersInfo, component.getNewProvidersInfo);
      }

      return component;
    };

    var _getNewProvidersInfo = function _getNewProvidersInfo(productId) {
      var url = '/' + productId + '.productBNPL' + '?isDesktop=' + component.isDesktop;

      if (new URLSearchParams(window.location.search).get('displayBuyNowPayLaterProviders') === 'true') url = url + '&displayBuyNowPayLaterProviders=true';

      app.ajax.get({
        url: url,
        success: component.successHandler,
        error: component.errorHandler
      });
    };

    var _successHandler = function _successHandler(response) {
      var parent = component.element.parentNode;
      parent.innerHTML = response;
      var element = parent.querySelector(component.config.selectors.component);
      component.init(element, true, component.isDesktop);
    };

    var _errorHandler = function _errorHandler() {
      console.error('ERROR: Could not retrieve new BNPL info');
    };

    component.init = _init;
    component.config = _config;
    component.getNewProvidersInfo = _getNewProvidersInfo;
    component.successHandler = _successHandler;
    component.errorHandler = _errorHandler;

    return component;
  };

  return productBuyNowPayLaterProviders;
});
//# sourceMappingURL=productBuyNowPayLaterProviders.js.map
